module.exports = __webpack_public_path__ + "static/media/cidade.2ba974d1.jpg";